export default __webpack_public_path__ + "static/hero_business_back_img_4-6cbfb38271f2d2dca0fd81e0892260ea.png";